import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Experience } from '../core/Experience';
import { ExperienceOverlay } from '../components/ExperienceOverlay';
import { ExperienceIntro } from '../components/ExperienceIntro';
import { useExperienceStore } from '../state/useExperienceStore';

export const Market3DPage = () => {
  const [searchParams] = useSearchParams();
  const { selectShop, selectProduct, setIntroComplete } = useExperienceStore();

  useEffect(() => {
    const shopId = searchParams.get('shop');
    const productId = searchParams.get('product');

    if (shopId || productId) {
      setIntroComplete(true);
      if (shopId) {
        selectShop(shopId);
      }
      if (productId) {
        selectProduct(productId);
      }
    }
  }, []);

  return (
    <div className="relative w-full h-[calc(100vh-64px)] overflow-hidden">
      <Experience />
      <ExperienceOverlay />
    </div>
  );
};
